import React, { useState } from "react";
import EditIcon from "../icons/edit";
import icondeleteDevise from "../../assets/delete.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../authProvider";
import ToggleMenuIcon from "../icons/toggleIcon";

const ResponsiveCard = ({ data, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [openMenuId, setOpenMenuId] = useState(null);

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  return (
    <div id="responsive-cards-users" className="responsive-card-wrapper ">
      {data.map((client) => (
        <div className="responsive-card" key={client._id}>
          <div className="top-right-menu">
            <button
              className="toggle-button"
              onClick={() => toggleMenu(client._id)}>
              <ToggleMenuIcon size={20} />
            </button>
            {openMenuId === client._id && (
              <div className=" show custom-dropdown">
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => {
                    toggleMenu(null);
                    navigate(`/viewUser/${client._id}`);
                  }}>
                  Détails
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => {
                    toggleMenu(null);
                    onEdit(client);
                  }}>
                  {/* <EditIcon /> */}
                  Modifier
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => {
                    toggleMenu(null);
                    onDelete(client._id);
                  }}>
                  {/* <img
                    src={icondeleteDevise}
                    alt="Supprimer"
                    className="delete-icon"
                  /> */}
                  Supprimer
                </button>
              </div>
            )}
          </div>

          <div className="card-body">
            <img
              src={`${process.env.REACT_APP_API_URL}/users/${client._id}/image`}
              alt="Client"
              className="client-image center"
            />
            <div className="client-info center">
              <h5>
                {client.firstname} {client.lastname}
              </h5>
              <p>{client.Role || "Rôle non défini"}</p>
              <p>{client.email}</p>
              <p>{client.status}</p>
              {/* <p>{new Date(client.createdAt).toLocaleDateString()}</p> */}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResponsiveCard;
